import i18n from '@/plugins/i18n';
import showAlert from '@/components/sweet-alert-popup.js';
import themeConfig from '@/theme/themeConfig';

/**
 * Displays an error dialog.
 *  @param {string} error error message that needs to be displayed.
 */
export function showErrorDialog(errorTitle, errorSubTitle) {
  let errorMessage = '';
  if (errorTitle) {
    errorMessage += `<p class="text-lg font-bold text-deep-dark mb-3">${errorTitle}</p> `;
  }
  errorMessage += `<p class="text-sm text-deep-dark"> ${errorSubTitle}</p>`;
  showAlert({
    iconType: 'alert-error',
    html: `
      <style>.swal2-confirm { color: ${themeConfig.appPrimaryColorInvert} !important; }</style>
      ${errorMessage}
    `,
    showCancelButton: false,
    showCloseButton: true,
    confirmButtonColor: themeConfig.appPrimaryColor,
    confirmButtonText: i18n.t('frontend_close')
  });
}

/**
 * Displays a success dialog.
 *  @param {string} success success message that needs to be displayed.
 */
export function showSuccessDialog(successTitle, successSubTitle) {
  let successMessage = '';
  if (successTitle) {
    successMessage += `<p class="text-lg font-bold text-deep-dark mb-3">${successTitle}</p> `;
  }
  successMessage += `<p class="text-sm text-deep-dark"> ${successSubTitle}</p>`;
  showAlert({
    iconType: 'alert-success',
    html: successMessage,
    showCancelButton: false,
    showCloseButton: true,
    confirmButtonColor: '#2f80ed',
    confirmButtonText: i18n.t(
      'frontend_close'
    ),
  });
}


// error message for the request field
export function showRequestErrorAlert(errorMessage) {
  return showAlert({
    iconType: 'alert-error',
    html : `
      <style>.swal2-cancel { color: ${themeConfig.appPrimaryColorInvert} !important; }</style>
      <p class="text-sm text-deep-dark mb-3">${errorMessage || this.$t('frontend_backend_error') }</p>
    `,
    showCancelButton: false,
    showCloseButton: true,
    confirmButtonColor: themeConfig.appPrimaryColor,
    confirmButtonText: this.$t('frontend_close'),
  });
}


/**
 * Displays a dialog box for confirmation.
 * @return {object} - returns a promise
 */
export function showQuestionDialog(quesTitle, quesSubTitle) {
  return showAlert({
    iconType: 'alert-question',
    html: `
      <style>.swal2-cancel { color: ${themeConfig.appPrimaryColorInvert} !important; }</style>
      <p class="text-lg font-bold text-deep-dark mb-3"> ${i18n.t(quesTitle)}</p>
      <p class="text-sm text-deep-dark"> ${i18n.t(quesSubTitle)}</p>
    `,
    showCancelButton: true,
    showCloseButton: true,
    confirmButtonColor: '#2f80ed',
    cancelButtonColor: themeConfig.appPrimaryColor,
    cancelButtonText: i18n.t('frontend_cancel'),
    confirmButtonText: i18n.t('frontend_groovemail_frontend_confirm')
  });
}
